import * as React from "react";
import { useState } from "react";

import { Input } from "../input";

import "./threeColumnMultiField.scss";

export const ThreeColumnMultiField = ({ specField, fullData }) => {
    const maxLengths = {
        columnOne: specField.columnOneMaxLength,
        columnTwo: specField.columnTwoMaxLength,
        columnThree: specField.columnThreeMaxLength
    };

    const columnOneField = fullData.find(field => field.fieldKey === specField.columnOneField);
    const columnTwoField = fullData.find(field => field.fieldKey === specField.columnTwoField);
    const columnThreeField = fullData.find(field => field.fieldKey === specField.columnThreeField);

    const [columnFieldValues, setColumnFieldValues] = useState({
        columnOne: columnOneField ? columnOneField.data : "",
        columnTwo: columnTwoField ? columnTwoField.data : "",
        columnThree: columnThreeField ? columnThreeField.data : ""
    });

    function changeHandler(event) {
        const newValName = event.target.name;
        const newVal = event.target.value;
        const fieldName = event.target.getAttribute("data-fieldname");
        if (newVal.length > maxLengths[newValName]) return;
        
        setColumnFieldValues(prevValues => ({
            ...prevValues,
            [newValName]: newVal
        }));

        fullData.find(field => field.fieldKey === fieldName).onChange(newVal);
    }

    return (
        <div className="three-column-multi-field">
            {specField.idDisplayStyle === 24 ? (
                <div className={specField.ordinal === 0 || specField.ordinal === 11 ? "multi-column-field first-or-last-row" : "multi-column-field"}>
                    <div className="column-fields-container">
                    <div className="column-text">{specField.columnOneField}</div>
                    <div className="column-text">{specField.columnTwoField}</div>
                    <div className="column-text">{specField.columnThreeField}</div>
                    </div>
                </div>
            ) : null}
            {specField.idDisplayStyle === 25 ? (
            <div className={specField.ordinal === 0 || specField.ordinal === 11 ? "multi-column-field first-or-last-row" : "multi-column-field"}>
                <div className="column-fields-container">
                    <Input
                        inputField
                        inputFieldName={"columnOne"}
                        inputType="text"
                        dataFieldName={specField.columnOneField}
                        fieldValue={columnFieldValues.columnOne}
                        className="column-input"
                        changeHandler={changeHandler}
                        extraInfo={{ "data-ignoreSave": "true" }}
                    />
                    <Input
                        inputField
                        inputFieldName={"columnTwo"}
                        inputType="text"
                        dataFieldName={specField.columnTwoField}
                        fieldValue={columnFieldValues.columnTwo}
                        className="column-input"
                        changeHandler={changeHandler}
                        extraInfo={{ "data-ignoreSave": "true" }}
                    />
                    <Input
                        inputField
                        inputFieldName={"columnThree"}
                        inputType="text"
                        dataFieldName={specField.columnThreeField}
                        fieldValue={columnFieldValues.columnThree}
                        className="column-input"
                        changeHandler={changeHandler}
                        extraInfo={{ "data-ignoreSave": "true" }}
                    />
                </div>
            </div>
            ) : null}
        </div>
    );
};
